<p [ngClass]="textColor" class="text-sm mobile:text-xs">{{ 'auth.onboarding_step_4.privacy.first_part' |
    transloco }}<a [href]="termsAndConditionsURL" class="text-primary hover:underline">{{
        'auth.onboarding_step_4.privacy.second_part' | transloco }}</a>{{ 'auth.onboarding_step_4.privacy.third_part' |
    transloco }}
</p>